/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free normality calculator. Compute the normality of a concentrated acid or base from density, assay (%) and equivalent weight, or solve for any of those.`)
};

const es_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de normalidad. Calcula la normalidad de un ácido o base concentrados a partir de la densidad, el ensayo (%) y el peso equivalente, o calcula cualquiera de esos valores.`)
};

const de_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Normalitätsrechner. Berechnen Sie die Normalität einer konzentrierten Säure oder Base aus Dichte, Gehalt (%) und Äquivalentgewicht, oder lösen Sie nach einem dieser Werte.`)
};

const nl_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis normaliteitscalculator. Bereken de normaliteit van een geconcentreerd zuur of base uit dichtheid, gehalte (%) en equivalentgewicht, of bereken een van deze waarden.`)
};

const fr_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de normalité. Calculez la normalité d'un acide ou d'une base concentrés à partir de la densité, du titre (%) et de l'équivalent-gramme, ou résolvez pour l'une de ces valeurs.`)
};

const it_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di normalità. Calcola la normalità di un acido o base concentrati da densità, titolo (%) e peso equivalente, o risolvi uno qualsiasi di questi valori.`)
};

const pt_br2_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de normalidade. Calcule a normalidade de um ácido ou base concentrado a partir da densidade, teor (%) e peso equivalente, ou resolva qualquer um desses valores.`)
};

const pt_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de normalidade. Calcule a normalidade de um ácido ou base concentrados a partir da densidade, título (%) e equivalente-grama, ou resolva para qualquer um destes.`)
};

const ja_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の規定度計算ツール。密度、アッセイ (%)、当量から濃縮酸または濃縮塩基の規定度を計算、またはそれらのいずれかを求めます。`)
};

const zh_norm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费当量浓度计算器。根据密度、含量（%）和当量重量计算浓缩酸或碱的当量浓度，也可反向求解其中任意一项。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_meta_description", locale)
	if (locale === "en") return en_norm_meta_description(inputs)
	if (locale === "es") return es_norm_meta_description(inputs)
	if (locale === "de") return de_norm_meta_description(inputs)
	if (locale === "nl") return nl_norm_meta_description(inputs)
	if (locale === "fr") return fr_norm_meta_description(inputs)
	if (locale === "it") return it_norm_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_norm_meta_description(inputs)
	if (locale === "pt") return pt_norm_meta_description(inputs)
	if (locale === "ja") return ja_norm_meta_description(inputs)
	return zh_norm_meta_description(inputs)
};